<template>
  <div>
    <transition name="fade">
      <div v-if="loading.district" class="statistics__loader-wrapper">
        <Spinner />
      </div>
    </transition>
    <h2 class="statistics__header-truncate">Opkomst vergelijking {{ districtIsSelected ? selectedDistrict.Title.Naam._text : '' }}</h2>
    <div class="statistics__turnup">
      <div class="statistics__graphs-container">
        <HorBar v-if="votingBehaviorStats" :args="votingBehaviorStats" style="height: 160px" />
      </div>
      <table class="statistics__turnup-table">
        <thead>
          <td/>
          <td>Verkiezing</td>
          <td>Kiesgerechtigden</td>
          <td>Opkomst</td>
        </thead>
        <tr v-for="(year, key) in totals" :key="key">
          <td><div :style="{'borderColor': getProvinceSetting.color}" class="legend"/></td>
          <td>{{ key.replace('PS', '20') }}</td>
          <td>{{ $numberWithDots(year.kiesgerechtigden.Stemmen._text) }}</td>
          <td>{{ $numberWithDots(year.opkomst.Stemmen._text) }}</td>
        </tr> 
      </table>
    </div> 
  </div> 
</template>

<script>
import { mapState, mapGetters } from "vuex";
import HorBar from "../charts/HorBar.vue";
import Spinner from "../Spinner.vue";

export default {
  components: { HorBar, Spinner },
  data() {
    return {
      provincialVoteView: false,
      sortOnValues: false
    };
  },
  computed: {
    ...mapState({
      demographic: state => state.feed.provincialData.demographic,
      selectedDistrict: state => state.feed.selectedDistrict,
      seats: state => state.feed.provincialData.seats,
      loading: state => state.feed.loading,
      lastUpdated: state => state.feed.lastUpdated
    }),
    ...mapGetters("feed", [
      "provincialPartySeats",
      "votingBehavior",
      "districtPartyResults",
      "getCompletedDistricts",
      "getProvincialTotals",
      "getProvinceSetting",
      "provincialPartyVotes"
    ]),
    votingBehaviorStats() {
      return this.votingBehavior(!!this.selectedDistrict);
    },
    totals() {
      return this.getProvincialTotals(!!this.selectedDistrict);
    },

    districtIsSelected() {
      return Object.keys(this.selectedDistrict).length;
    }
  },
  methods: {}
};
</script>

<style lang="scss">
@import "../../util.scss";

/* styling is inherited from parent */

.statistics__header-truncate {
  @include truncate();
  display: block !important;
}
</style>
